import { render, staticRenderFns } from "./SocietyMatchesRequestView.vue?vue&type=template&id=134aedd5&scoped=true"
import script from "./SocietyMatchesRequestView.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesRequestView.vue?vue&type=script&lang=js"
import style0 from "./SocietyMatchesRequestView.vue?vue&type=style&index=0&id=134aedd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134aedd5",
  null
  
)

export default component.exports